import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Search } from "lucide-react";
import Pagination from "../components/Pagination";
import PageHeader from "../components/PageHeader";

const ACTION_COLORS = {
  create: { bg: "#DCFCE7", fg: "#166534" },
  update: { bg: "#DBEAFE", fg: "#1E3A8A" },
  delete: { bg: "#FEE2E2", fg: "#991B1B" },
  login:  { bg: "#F1F5F9", fg: "#475569" },
};

export default function Logs() {
  const [data, setData] = useState({ items: [], page: 1, pages: 1, total: 0 });
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");

  const load = () => api.get("/logs", { params: { page, q } }).then(r => setData(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [page]);

  return (
    <div data-testid="logs-page">
      <PageHeader title="Logs" subtitle="Auditoria de todas as ações da plataforma" testid="logs-header" />

      <div className="a4w-card p-2 mb-4 flex items-center gap-2">
        <Search size={18} className="ml-2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (page === 1 ? load() : setPage(1))}
          placeholder="Pesquisar por ação, entidade, email…" className="border-0 focus-visible:ring-0 shadow-none" data-testid="logs-search" />
        <Button variant="outline" onClick={() => (page === 1 ? load() : setPage(1))} data-testid="logs-search-btn">Pesquisar</Button>
      </div>

      <div className="a4w-card overflow-hidden">
        <table className="w-full text-sm" data-testid="logs-table">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-4 py-3 a4w-label">Data/Hora</th>
              <th className="px-4 py-3 a4w-label">Utilizador</th>
              <th className="px-4 py-3 a4w-label">Ação</th>
              <th className="px-4 py-3 a4w-label">Entidade</th>
              <th className="px-4 py-3 a4w-label">Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map(l => {
              const c = ACTION_COLORS[l.action] || { bg: "#F1F5F9", fg: "#475569" };
              return (
                <tr key={l.id} className="border-t border-slate-100 a4w-table-row">
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{fmtDateTime(l.created_at)}</td>
                  <td className="px-4 py-3">{l.user_email}</td>
                  <td className="px-4 py-3"><Badge style={{ background: c.bg, color: c.fg }}>{l.action}</Badge></td>
                  <td className="px-4 py-3 text-slate-600 capitalize">{l.entity}</td>
                  <td className="px-4 py-3 text-slate-600">{l.details}</td>
                </tr>
              );
            })}
            {data.items.length === 0 && (
              <tr><td colSpan="5" className="px-4 py-10 text-center text-slate-500">Sem registos.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination page={data.page} pages={data.pages} total={data.total} onChange={setPage} />
    </div>
  );
}
